module.exports = __webpack_public_path__ + "dingbeauty-build/img/service3@1.99518311.jpg";